import { VerificationCountsByLocationIdsResponse } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';
import { createShallowStore, createStore } from '@frontend/store';

type InsuranceStatusesStore = {
  insuranceStatuses?: Record<string, VerificationCountsByLocationIdsResponse>;
  setInsuranceStatuses: (calendarDate: string, statuses: VerificationCountsByLocationIdsResponse) => void;
};

export const useGetInsuranceStatusesStore = createStore<InsuranceStatusesStore>(
  (set) => ({
    insuranceStatuses: {},
    setInsuranceStatuses: (calendarDate, statuses) =>
      set((state) => ({
        ...state,
        insuranceStatuses: {
          ...state.insuranceStatuses,
          [calendarDate]: statuses,
        },
      })),
  }),
  {
    name: 'insuranceStatusesStore',
  }
);

export const useGetInsuranceStatusesStoreShallow =
  createShallowStore<InsuranceStatusesStore>(useGetInsuranceStatusesStore);
